import { Component, Input } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CardPageService } from '../../services/card-page/card-page.service';

/**
 * @description
 * A detail view  of a callcard
 */
@Component({
  templateUrl: 'callcard-detail-content.component.html',
  styleUrls: ['./callcard-detail-content.component.scss'],
  selector: 'callcard-detail-content'
})
export class CallcardDetailContentComponent {
  @Input() callcard: CallCard;

  get page(): number {
    return this._pages.getPage(this.callcard) || 0;
  }

  constructor(private _pages: CardPageService) {}
}
